import { SidebarNavigationInterface } from "./Interfaces.constants";
import icon from "../../assets/temp/info.svg";
import notes from "../../assets/temp/megaphone.svg";
import person from "../../assets/temp/user.svg";
import que from "../../assets/temp/quee.svg";
import square from "../../assets/temp/Squaree.svg";
import cal from "../../assets/temp/Calendersss.svg";
import notebook from "../../assets/temp/notebook.svg";
import grp from "../../assets/temp/Community.svg";
import cake from "../../assets/temp/Cakee.svg";
import eye from "../../assets/temp/eye.svg";
import pdf from "../../assets/temp/pdf.svg";
import calcu from "../../assets/temp/calcu.svg";
import gal from "../../assets/temp/gal1.svg";
import cam from "../../assets/temp/cam.svg";
import list from "../../assets/temp/list.svg";
import thumb from "../../assets/temp/thumb.svg";
import homefy from "../../assets/temp/homefy.svg";
import CalendarIcon from "../../assets/temp/Calendar.svg";
import calcuu from "../../assets/temp/calendar-symbol.svg";
import chat from "../../assets/temp/chat.svg";
import leaderboard from "../../assets/temp/leaderboard.svg";
import service from "../../assets/temp/service-provider-icon.svg";
import group from "../../assets/temp/group.svg";
import trainer from "../../assets/temp/training.svg";
import gallary from "../../assets/temp/photo-icon.svg";

const SidebarConst: Array<SidebarNavigationInterface> = [
  {
    id: 100,
    iconURL: homefy,
    routeLabel: "dashboard",
    routePath: "/dashboard",
    subItems: [],
  },
  // {
  //   id: 101,
  //   iconURL: icon,
  //   routeLabel: "About As One",
  //   routePath: "/about-as-one",
  //   subItems: []
  // },
  {
    id: 102,
    iconURL: notes,
    routeLabel: "Notification",
    routePath: "/notification",
    subItems: [],
  },
  {
    id: 103,
    iconURL: person,
    routeLabel: "People",
    routePath: "/people",
    subItems: [],
  },
  {
    id: 105,
    iconURL: group,
    routeLabel: "Group",
    routePath: "/group",
    subItems: [],
  },
  {
    id: 106,
    iconURL: trainer,
    routeLabel: "Training",
    routePath: "/trainings",
    subItems: [],
  },
  // {
  //   id: 107,
  //   iconURL:que ,
  //   routeLabel: "Training Quiz",
  //   routePath: "/training-quiz",
  //   subItems: []
  // },
  {
    id: 108,
    iconURL: gallary,
    routeLabel: "Gallery  ",
    routePath: "/sideMenu",
    subItems: [
      // {
      //   id: 1107,
      //   iconURL: pdf,
      //   routeLabel: "Corporate Communication",
      //   routePath: "/corporate-communication",
      //   subItems: []
      // },
      // {
      //   id: 1108,
      //   iconURL: pdf,
      //   routeLabel: "living responsibility",
      //   routePath: "/living-responsibility",
      //   subItems: []
      // },
      // {

      {
        id: 1110,
        iconURL: cam,
        routeLabel: "Add Gallery",
        routePath: "/gallery",
        subItems: [],
      },
      // {
      //   id: 1111,
      //   iconURL: gal,
      //   routeLabel: "Photos",
      //   routePath: "/photos",
      //   subItems: []
      // },
      {
        id: 1112,
        iconURL: cam,
        routeLabel: "Add Folder",
        routePath: "/add-folder",
        subItems: [],
      },
      // {
      //   id: 1113,
      //   iconURL: cam,
      //   routeLabel: "Add Gallery",
      //   routePath: "/gallery/add-gallery",
      //   subItems: []
      // },
    ],
  },
  {
    id: 109,
    iconURL: cal,
    routeLabel: "Wall ",
    routePath: "/wall",
    subItems: [
      {
        id: 1014,
        iconURL: list,
        routeLabel: "Wall Listing",
        routePath: "/wall",
        subItems: [],
      },
      // {
      //   id: 1015,
      //   iconURL: list,
      //   routeLabel: "Report User",
      //   routePath: "/report-user",
      //   subItems: []
      // }
      // {
      //   id: 1015,
      //   iconURL: thumb,
      //   routeLabel: "Schedule",
      //   routePath: "/sche",
      //   subItems: []
      // },
    ],
  },
  {
    id: 110,
    iconURL: cal,
    routeLabel: "Cultural Club",
    routePath: "/culturalClub",
    subItems: [
      {
        id: 1016,
        iconURL: list,
        routeLabel: "Post Listing",
        routePath: "/culturalPost",
        subItems: [],
      },
      // {
      //   id: 1017,
      //   iconURL: thumb,
      //   routeLabel: "Schedule Cultural Post",
      //   routePath: "/scp",
      //   subItems: []
      // },
    ],
  },
  {
    id: 111,
    iconURL: notebook,
    routeLabel: "My Connect",
    routePath: "/my-connect",
    subItems: [],
  },
  {
    id: 112,
    iconURL: grp,
    routeLabel: "New Activities",
    routePath: "/newActivities",
    subItems: [
      {
        id: 1030,
        iconURL: que,
        routeLabel: "Quiz & Training Quiz",
        routePath: "/quiz",
        subItems: [],
      },
      {
        id: 1031,
        iconURL: gal,
        routeLabel: "Photo Challenge",
        routePath: "/photo-challenge",
        subItems: [],
      },
      {
        id: 1032,
        iconURL: cam,
        routeLabel: "Video Challenge",
        routePath: "/video-challenge",
        subItems: [],
      },
      {
        id: 1033,
        iconURL: square,
        routeLabel: "Zigsaw Challenge",
        routePath: "/zigsaw-challenge",
        subItems: [],
      },
      {
        id: 1034,
        iconURL: que,
        routeLabel: "KahootQuiz",
        routePath: "/kahoot-quiz",
        subItems: [],
      },
      {
        id: 1035,
        iconURL: square,
        routeLabel: "Zoom And Webinar Links",
        routePath: "/zooms",
        subItems: [],
      },
    ],
  },
  {
    id: 1136,
    iconURL: leaderboard,
    routeLabel: "Leaderboard",
    routePath: "/leaderboard",
    subItems: [],
  },
  {
    id: 1137,
    iconURL: chat,
    routeLabel: "HR-Chat",
    routePath: "/hr-chat",
    subItems: [],
  },
  // {
  //   id: 1138,
  //   iconURL: service,
  //   routeLabel: "Service",
  //   routePath: "/birthdayTemplate",
  //   subItems: []
  // },
  {
    id: 1139,
    iconURL: calcu,
    routeLabel: "Survey",
    routePath: "/survey",
    subItems: [],
  },

  {
    id: 1140,
    iconURL: eye,
    routeLabel: "App Version",
    routePath: "/appVersion",
    subItems: [],
  },
  // {
  //   id: 1141,
  //   iconURL: eye,
  //   routeLabel: "Analytics",
  //   routePath: "/anylitics",
  //   subItems: [],
  // },
];

export default SidebarConst;

// // arr = []
// // res = [{id: 1, title: 'program'}]
// // res.map(item => arr.push({
// //   id: item.id,
// //   iconURL: list,
// //   routeLabel: item.title,
// //   routePath: "/cs",
// //   subItems: []
// // }))
